module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyt"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PUBLISHER:")])]), _vm._v(" Amy Marson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("CREATIVE DIRECTOR:")])]), _vm._v(" Gailen Runge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDITOR:")])]), _vm._v(" Lynn Koolish")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("TECHNICAL EDITOR:")])]), _vm._v(" Linda Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("COVER/BOOK DESIGNER:")])]), _vm._v(" Kerry Graham")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PRODUCTION COORDINATOR:")])]), _vm._v(" Joe Edge")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PRODUCTION EDITORS:")])]), _vm._v(" Jeanie German and Alice Mace Nakanishi")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("ILLUSTRATORS:")])]), _vm._v(" Becky Goldsmith and Linda Johnson")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("PHOTO ASSISTANT:")])]), _vm._v(" Mai Yong Vang")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_c('span', {
    staticClass: "small"
  }, [_vm._v("HAND MODEL:")])]), _vm._v(" Kristi Visser")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("Photography by Diane Pedersen of C&T Publishing, Inc., unless otherwise noted")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("Published by C&T Publishing, Inc.,"), _c('br'), _vm._v("P.O. Box 1456, Lafayette, CA 94549")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1117ebab","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_copyrighttitle.vue
// module id = 60
// module chunks = 0